import {call, put, takeEvery } from "redux-saga/effects";

import {
  POST_SIGNOZ_ENABLE_DISABLE_ALERTS,
  POST_SIGNOZ_CREATE_RESOURCE_ALERTS,
  GET_SIGNOZ_ALERTS,
  GET_SIGNOZ_DEFAULT_THRESHOLD,
  GET_SIGNOZ_RESOURCE_BY_ID,
  GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
  POST_SIGNOZ_ALERT,
  GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  POST_SIGNOZ_SERVICE_MAPPING,
  GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES,
  GET_SIGNOZ_RESOURCES,
  GET_RESCAN_STATUS_SIGNOZ,
  POST_UPDATE_SIGNOZ_THRESHOLD,
  POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD, GET_SIGNOZ_RESCAN,
  GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_SIGNOZ_THRESHOLD,
  GET_SIGNOZ_ALL_EXTERNAL_SERVICES,
  GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS,
  POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
GET_SIGNOZ_NON_KEY_TRANSACTIONS
} from "./actionTypes";

import {
    postSignozEnableDisableAlertsSuccess,
    postSignozEnableDisableAlertsFail,
    postSignozCreateResourceAlertsSuccess,
    postSignozCreateResourceAlertsFail,
    postSignozCreateDynamicAlertSuccess,
    postSignozCreateDynamicAlertFail,
    getSignozAlertsFail,
    getSignozAlertsSuccess,
    getSignozDynamicAlertsFail,
    getSignozDynamicAlertsSuccess,
    getSignozMissingDynamicAlertsFail,
    getSignozMissingDynamicAlertsSuccess,
    getSignozDefaultThresholdFail,
    getSignozDefaultThresholdSuccess,
    getSignozResourceByIdFail,
    getSignozResourceByIdSuccess,
    getSignozResourcesDefaultThresholdByIdFail,
    getSignozResourcesDefaultThresholdByIdSuccess,
    postSignozAlertFail,
    postSignozAlertsSuccess,
    getSignozRescanFail,
    getSignozRescanSuccess,
    getSignozMissingAlertByResourceIdFail,
    getSignozMissingAlertsByResourceIdSuccess,
    getSignozAllResourceAlertsPageFail,
    getSignozAllResourceAlertsPageSuccess,
    getSignozAllResourceAlertsCountPageFail,
    getSignozAllResourceAlertsCountPageSuccess,
    postSignozServiceMappingFail,
    postSignozServiceMappingSuccess,
    getSignozResourcesFail,
    getSignozResourcesSuccess,
    getAllOrgSignozResourceTypesFail,
    getAllOrgSignozResourceTypesSuccess,
    getRescanStatusSignozFail,
    getRescanStatusSignozSuccess,
    postUpdateSignozThresholdFail,
    postUpdateSignozThresholdSuccess,
    postEnableDisableSignozThresholdFail,
    postEnableDisableSignozThresholdSuccess,
    getSignozThresholdFail,
    getSignozThresholdSuccess,
    getSignozAllExternalServicesPageSuccess,
    getSignozAllExternalServicesPageFail,
    getSignozAllBusinessTransactionsSuccess,
    getSignozAllBusinessTransactionsFail,
    getSignozNonKeyTransactionsFail,
    getSignozNonKeyTransactionsSuccess,
    getMissingSignozAlertsByResourceIDSuccess,
    getMissingSignozAlertsByResourceIDFail,
    postMarkNonKeySignozTransactionAsBusinessTransactionSuccess,
    postMarkNonKeySignozTransactionAsBusinessTransactionFail
} from "./actions";

 import {
    postSignozEnableDisableAlertsUrl,
    postSignozCreateResourceAlertsUrl,
    postSignozCreateDynamicAlertUrl,
    getSignozAlertUrl,
    getSignozDynamicAlertsUrl,
    getSignozMissingDynamicAlertsUrl,
    getSignozDefaultThresholdUrl,
    getSignozResourceDefaultThresholdByIdUrl,
    postSignozAlertUrl,
    getSignozRescanUrl,
    getSignozMissingAlertByResourceIdUrl,
    getSignozAllResourceAlertsPageUrl,
    getSignozAllResourceAlertsCountPageUrl,
    getSignozAllBusinessTransactionAlertsUrl,
    getSignozAllExternalServicesURL,
    postSignozServiceMappingUrl,
    getSignozResourcesUrl,
    getAllOrgSignozResourceTypesUrl,
    getRescanStatusSignozUrl,
    postUpdateSignozThresholdUrl,
    postEnableDisableSignozThresholdUrl,
    getSignozResourceByIDUrl,
    getSignozThresholdUrl,
    getSignozNonKeyTransactionsByParentResourceUrl,
    postMarkNonKeySignozTransactionAsBusinessTransactionUrl
} from "helpers/fakebackend_helper";


  function* onPostEnableDisableSignozThreshold({payload:data}) {
    try{
      const response = yield call(postEnableDisableSignozThresholdUrl, data) 
      yield put(postEnableDisableSignozThresholdSuccess(response));
    } catch(error) {
      yield put(postEnableDisableSignozThresholdFail(error));
    }
  }

  function* onPostUpdateSignozThreshold({payload:data}) {
    try{
      const response = yield call(postUpdateSignozThresholdUrl, data)
      yield put(postUpdateSignozThresholdSuccess(response))
    } catch(error) {
      yield put(postUpdateSignozThresholdFail(error))
    }
  }

  function* onGetRescanStatusSignoz() {
    try{
      const response = yield call(getRescanStatusSignozUrl)
      yield put(getRescanStatusSignozSuccess(response))
    } catch(error) {
      yield put(getRescanStatusSignozFail(error))
    }
  } 

  function* onGetAllOrgSignozResourceTypes() {
    try{
      const response = yield call(getAllOrgSignozResourceTypesUrl)
      yield put(getAllOrgSignozResourceTypesSuccess(response))
    } catch(error) {
      yield put(getAllOrgSignozResourceTypesFail(error))
    }
  }

  function* onGetSignozResources() {
    try{
      const response = yield call(getSignozResourcesUrl)
      yield put(getSignozResourcesSuccess(response))
    } catch(error) {
      yield put(getSignozResourcesFail(error))
    }
  }

  function* onPostSignozServiceMapping(data) {
    try{
      const response = yield call(postSignozServiceMappingUrl, data.payload)
      yield put(postSignozServiceMappingSuccess(response))
      window.location.reload()
    } catch(error) {
      yield put(postSignozServiceMappingFail(error))
    }
  }

  function* onGetSignozAllResourceAlertsPage({payload:data}) {
    try{
      const response = yield call(getSignozAllResourceAlertsPageUrl, data);
      yield put(getSignozAllResourceAlertsPageSuccess(response));
    } catch(error) {
      yield put(getSignozAllResourceAlertsPageFail(error))
    }
  }

  function* onGetSignozAllResourceAlertsCountPage({payload:data}) {
    try{
      const response = yield call(getSignozAllResourceAlertsCountPageUrl, data)
      yield put(getSignozAllResourceAlertsCountPageSuccess(response));
    } catch(error) {
      yield put(getSignozAllResourceAlertsCountPageFail(error))
    }
  }

  function* onGetSignozMissingAlertByResourceId(monitored_resource_id) {
    try{
      const response = yield call(getSignozMissingAlertByResourceIdUrl, monitored_resource_id)
      yield put(getSignozMissingAlertsByResourceIdSuccess(response))
    } catch(error) {
      yield put(getSignozMissingAlertByResourceIdFail(error))
    } 
  }
  
  function* onGetSignozRescan() {
    try{
      const response = yield call(getSignozRescanUrl);
      yield put(getSignozRescanSuccess(response))
    } catch(error) {
      yield put(getSignozRescanFail(error))
    }
  }

  function* onPostSignozAlert({payload:data}) {
    try{
      const response = yield call(postSignozAlertUrl, data)
      yield put(postSignozAlertsSuccess(response))
    } catch(error) {
      yield put(postSignozAlertFail(error))
    }
  }

  function* onGetSignozResourceDefaultThresholdById(data) {
    try{
      const response = yield call(getSignozResourceDefaultThresholdByIdUrl, data.payload)
      yield put(getSignozResourcesDefaultThresholdByIdSuccess(response))
    } catch(error) {
      yield put(getSignozResourcesDefaultThresholdByIdFail(error))
    } 
  }

  function* onPostSignozEnableDisableAlerts({payload: {data}}){
    try{
      const response = yield call(postSignozEnableDisableAlertsUrl, data)
      yield put(postSignozEnableDisableAlertsSuccess(response));
    } catch(error) {
      yield put(postSignozEnableDisableAlertsFail(error))
    }
  }

  function* onPostSignozCreateResourceAlerts({payload: {data}}){
    try{
      const response = yield call(postSignozCreateResourceAlertsUrl, data)
      yield put(postSignozCreateResourceAlertsSuccess(response));
    } catch(error) {
      yield put(postSignozCreateResourceAlertsFail(error))
    }
  }

  function* onPostSignozCreateDynamicAlert({payload: {data}}){
    try{
      const response = yield call(postSignozCreateDynamicAlertUrl, data)
      yield put(postSignozCreateDynamicAlertSuccess(response));
    } catch(error) {
      yield put(postSignozCreateDynamicAlertFail(error))
    }
  }

  function* onGetSignozAlerts({payload:monitored_resource_id}) {
    try{
      const response = yield call(getSignozAlertUrl, monitored_resource_id)
      yield put(getSignozAlertsSuccess(response));
    } catch(error) {
      yield put(getSignozAlertsFail(error))
    }
  }

  function* onGetSignozDynamicAlerts({payload:monitored_resource_id}) {
    try{
      const response = yield call(getSignozDynamicAlertsUrl, monitored_resource_id)
      yield put(getSignozDynamicAlertsSuccess(response))
    } catch(error) {
      yield put(getSignozDynamicAlertsFail(error));
    }
  }

  function* onGetSignozMissingDynamicAlerts(monitored_resource_id) {
    try{
      const response = yield call(getSignozMissingDynamicAlertsUrl, monitored_resource_id)
      yield put(getSignozMissingDynamicAlertsSuccess(response))
    } catch(error){
      yield put(getSignozMissingDynamicAlertsFail(error));
    }
  }

  function* onGetSignozDefaultThreshold(threshold_type) {
    try{
      const response = yield call(getSignozDefaultThresholdUrl, threshold_type)
      yield put(getSignozDefaultThresholdSuccess(response))
    } catch(error) {
      yield put(getSignozDefaultThresholdFail(error))
    }
  }

  function* onGetSignozThreshold() {
    try{
      const response = yield call(getSignozThresholdUrl)
      yield put(getSignozThresholdSuccess(response))
    } catch(error) {
      yield put(getSignozThresholdFail(error))
    }
  }

  function* onGetSignozResourceById({payload:data}) {
    try{
      const response = yield call(getSignozResourceByIDUrl,data);
      yield put(getSignozResourceByIdSuccess(response));
    } catch(error) {
      yield put(getSignozResourceByIdFail(error))
    }
  }

function* onGetSignozMissingAlertsByResourceID(monitored_resource_id) {
    try {
        const response = yield call(getSignozMissingAlertByResourceIdUrl, monitored_resource_id.payload);
        yield put(getMissingSignozAlertsByResourceIDSuccess(response));
    } catch (error) {
        yield put(getMissingSignozAlertsByResourceIDFail(error.message));
    }
}

function* onGetSignozAllBusinessTransactionsPage({payload:data}) {
    try{
        const response = yield call(getSignozAllBusinessTransactionAlertsUrl, data)
        yield put(getSignozAllBusinessTransactionsSuccess(response));
    } catch(error) {
        yield put(getSignozAllBusinessTransactionsFail(error))
    }
}

function* onGetSignozAllExternalServicesPage({payload:data}) {
    try{
        const response = yield call(getSignozAllExternalServicesURL, data)
        yield put(getSignozAllExternalServicesPageSuccess(response));
    } catch(error) {
        yield put(getSignozAllExternalServicesPageFail(error))
    }
}

function* onGetSignozNonKeyTransactionsByParentResource({payload:data}) {
    try {
        const response = yield call(getSignozNonKeyTransactionsByParentResourceUrl, data)
        yield put(getSignozNonKeyTransactionsSuccess(response));
    } catch (error) {
        yield put(getSignozNonKeyTransactionsFail(error))
    }
}

function* onPostMarkNonKeyTransactionAsBusinessTransaction({payload:data}) {
    try {
        const response = yield call(postMarkNonKeySignozTransactionAsBusinessTransactionUrl, data)
        yield put(postMarkNonKeySignozTransactionAsBusinessTransactionSuccess(response));
    } catch (error) {
        yield put(postMarkNonKeySignozTransactionAsBusinessTransactionFail(error))
    }
}

  function* SignozSaga(){
    yield takeEvery(GET_SIGNOZ_RESOURCE_BY_ID, onGetSignozResourceById);
    yield takeEvery(POST_SIGNOZ_ENABLE_DISABLE_ALERTS, onPostSignozEnableDisableAlerts);
    yield takeEvery(POST_SIGNOZ_CREATE_RESOURCE_ALERTS, onPostSignozCreateResourceAlerts);
    yield takeEvery(GET_SIGNOZ_ALERTS, onGetSignozAlerts);
    yield takeEvery(GET_SIGNOZ_DEFAULT_THRESHOLD, onGetSignozDefaultThreshold);
    yield takeEvery(GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID, onGetSignozResourceDefaultThresholdById);
    yield takeEvery(POST_SIGNOZ_ALERT, onPostSignozAlert);
    yield takeEvery(GET_SIGNOZ_RESCAN, onGetSignozRescan);
    yield takeEvery(GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID, onGetSignozMissingAlertByResourceId);
    yield takeEvery(POST_SIGNOZ_SERVICE_MAPPING, onPostSignozServiceMapping);
    yield takeEvery(GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE, onGetSignozAllResourceAlertsPage);
    yield takeEvery(GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE, onGetSignozAllResourceAlertsCountPage);
    yield takeEvery(GET_SIGNOZ_RESOURCES, onGetSignozResources);
    yield takeEvery(GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES, onGetAllOrgSignozResourceTypes);
    yield takeEvery(GET_RESCAN_STATUS_SIGNOZ, onGetRescanStatusSignoz);
    yield takeEvery(POST_UPDATE_SIGNOZ_THRESHOLD, onPostUpdateSignozThreshold);
    yield takeEvery(POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD, onPostEnableDisableSignozThreshold);
    yield takeEvery(GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID, onGetSignozMissingAlertsByResourceID);
    yield takeEvery(GET_SIGNOZ_THRESHOLD, onGetSignozThreshold);
    yield takeEvery(GET_SIGNOZ_ALL_EXTERNAL_SERVICES, onGetSignozAllExternalServicesPage);
    yield takeEvery(GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS, onGetSignozAllBusinessTransactionsPage);
    yield takeEvery(GET_SIGNOZ_NON_KEY_TRANSACTIONS, onGetSignozNonKeyTransactionsByParentResource);
    yield takeEvery(POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION, onPostMarkNonKeyTransactionAsBusinessTransaction);
  }

 export default SignozSaga;